<template>
  <v-dialog
    v-model="storeTransferDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="50%"
    persistent
  >
    <v-card>
      <v-toolbar
        dark
        color="secondary"
        class="elevation-0"
      >
        <v-btn
          icon
          dark
          @click.native="storeTransferDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>העברת חנות</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-2"
          depressed
          large
          :loading="sending"
          :disabled="sending"
          @click="send"
        >
          ביצוע העברה
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-textarea
          name="imeiList"
          label="מכשירים להעברה"
          value=""
          v-model="imeiList"
          rows="5"
          hint="אפשר להזין רשימה של מספרי IMEI, כל אחד בשורה נפרדת או מופרדים בפסיקים"
        ></v-textarea>
        <v-select
          :items="stores"
          item-value="_id"
          item-text="title"
          label="חנות"
          v-model="store"
        ></v-select>
        <v-select
          :items="storeBoxTypes"
          item-value="_id"
          item-text="title"
          label="מגירה"
          v-model="boxType"
        ></v-select>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getApi } from "@/api";
import Mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      sending: false,
      imeiList: "",
      store: null,
      boxType: null
    };
  },

  computed: {
    storeTransferDialog: {
      get() {
        return this.$store.state.storeTransferDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_STORE_TRANSFER_DIALOG", isActive);
      }
    },
    stores() {
      return this.$store.getters["entityList"]("stores");
    },
    storeBoxTypes() {
      if (this.store) {
        let store = this.$store.state.entities.stores[this.store];
        if (store) {
          let boxTypes = store.boxTypes;
          if (boxTypes) {
            return boxTypes
              .map(item => {
                return this.$store.state.entities.boxTypes[item];
              })
              .filter(item => {
                return !!item;
              });
          }
        }
      }
      return [];
    }
  },

  methods: {
    send() {
      this.sending = true;

      getApi()
        .then(api => {
          let params = {
            imeiList: this.imeiList,
            store: this.store,
            boxType: this.boxType
          };
          return api.post("/store-transfers", params);
        })
        .then(() => {
          this.storeTransferDialog = false;
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "העברת חנות הסתיימה בהצלחה",
            color: "success"
          });
        })
        .catch(err => {
          this.showError(err);
        })
        .finally(() => {
          this.sending = false;
        });
    }
  },

  props: ["imei"],

  mixins: [Mixins],

  watch: {
    storeTransferDialog: {
      handler: function(val) {
        if (val) {
          this.imeiList = this.imei;
        } else {
          this.imeiList = "";
          this.store = null;
          this.boxType = null;
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
